export enum TournamentPanelType {
  Name,
  Date,
  Teams,
  PrizesAndDistribution,
  MatchSetup,
  SubMatchConfig,
  Admins,
  Spectators,
  Description,
  Assets,
}
